import { render, staticRenderFns } from "./WelcomeComponent.vue?vue&type=template&id=96af5e84&scoped=true"
import script from "./WelcomeComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeComponent.vue?vue&type=script&lang=js"
import style0 from "./WelcomeComponent.vue?vue&type=style&index=0&id=96af5e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96af5e84",
  null
  
)

export default component.exports